
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import TextArea from "components/forms/TextArea";
import { BiEditAlt } from 'react-icons/bi'
import SectionWrapper from "components/wrappers/SectionWrapper";
import Language from "components/Language";
import PropTypes from 'prop-types';

const EditFaq = ({ disabled, onUpdate, data }) => {
    const { t } = useTranslation();

    const { register, handleSubmit, formState: { errors } } = useForm();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])


    const onSubmit = (data) => {
        onUpdate(data)
        setIsOpen(false)
    }


    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${disabled ? 'bg-gray-200 text-gray-400' : '  focus:ring-gray-200 hover:bg-gray-200'}`}
                onClick={() => setIsOpen(true)}>
                <BiEditAlt />
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('actions.edit') + " " + t('form.faq')}
            >
                <form className="w-[480px]  lg:w-[720px]" onSubmit={handleSubmit(onSubmit)}>

                    {/* Question */}
                    <SectionWrapper
                        title={t('form.question')}
                    >

                        <TextArea
                            id="question.french"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('form.question') + t('form.in') + t('languages.fr')}
                            register={register("question.french", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.french}
                            defaultValue={data?.question.french}
                        />
                        <TextArea
                            id="question.arabic"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('form.question') + t('form.in') + t('languages.ar')}
                            register={register("question.arabic", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.arabic}
                            defaultValue={data?.question.arabic}
                        />
                        <TextArea
                            id="question.english"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('form.question') + t('form.in') + t('languages.en')}
                            register={register("question.english", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.english}
                            defaultValue={data?.question.english}
                        />
                    </SectionWrapper>


                    {/* Answer */}
                    <SectionWrapper
                        title={t('form.response')}
                    >
                        <TextArea
                            id="response.arabic"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('form.response') + t('form.in') + t('languages.ar')}
                            register={register("response.arabic", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.response?.arabic}
                            defaultValue={data?.response?.arabic}
                        />
                        <TextArea
                            id="response.french"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('form.response') + t('form.in') + t('languages.fr')}
                            register={register("response.french", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.response?.french}
                            defaultValue={data?.response?.french}
                        />

                        <TextArea
                            id="response.english"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('form.response') + t('form.in') + t('languages.en')}
                            register={register("response.english", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.response?.english}
                            defaultValue={data?.response?.english}
                        />
                    </SectionWrapper>

                    {/* Actions  */}

                    <div className="justify-end flex items-center mt-8">
                        <input type='button' value={t('actions.cancel')} onClick={() => setIsOpen(false)}
                            className='font-medium  text-sm capitalize bg-gray-100 rounded  px-4 py-2  mx-2 border-1 border-gray-500  cursor-pointer hover:bg-gray-300 shadow'
                        />
                        <input
                            className='capitalize font-medium    text-white bg-blue-500 rounded  px-4 py-2  mx-2 border-1 border-blue-500 shadow-md  cursor-pointer hover:bg-blue-600'
                            type="submit" value={t('actions.create')} />
                    </div>
                </form>


            </ModalWrapper>


        </>

    );

}

export default EditFaq;

EditFaq.propTypes = {
  disabled: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  data: PropTypes.object,
};

